import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="w-full bg-[#0a0a0a] py-8 md:py-16 px-4 border-t-4 border-gray-800" data-id="element-240">
      <div className="max-w-3xl mx-auto" data-id="element-241">
        <div className="bg-[#111] p-6 md:p-12 rounded-lg border-l-8 border-[#c41e3a] shadow-lg" data-id="element-242">
          <p className="text-xs md:text-sm text-[#c41e3a] font-black tracking-widest uppercase mb-3" data-id="element-243">
            La diferencia del método
          </p>
          <h2 className="text-2xl md:text-4xl font-black text-white mb-4 md:mb-6 leading-tight" data-id="element-244">
            Una formación con estructura real,{' '}
            <span className="text-[#c41e3a]" data-id="element-245">no un curso improvisado</span>
          </h2>
          <div className="w-12 h-0.5 bg-[#c41e3a] mb-4 md:mb-6" data-id="element-246"></div>
          <p className="text-sm md:text-lg text-gray-300 leading-relaxed mb-5 md:mb-6" data-id="element-247">
            Vas a aprender a{' '}
            <strong className="text-white" data-id="element-248">analizar, decidir y ejecutar</strong>{' '}
            cada corte con criterio profesional. No copiando técnicas, sino
            entendiendo el proceso completo.
          </p>
          <div className="space-y-2" data-id="element-249">
            {['Sabés por qué hacés cada paso, no solo cómo', 'Podés adaptar el método a cualquier tipo de corte', 'Trabajás con más seguridad y menos errores'].map(item => <div key={item} className="flex items-center gap-2 text-gray-200" data-id="element-250">
                <CheckCircleIcon className="w-4 h-4 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-251" />
                <span className="text-sm md:text-base font-semibold" data-id="element-252">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}